/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralCodeMetadata
 */
export interface ReferralCodeMetadata {
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeMetadata
     */
    sender_name: string;
}

/**
 * Check if a given object implements the ReferralCodeMetadata interface.
 */
export function instanceOfReferralCodeMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sender_name" in value;

    return isInstance;
}

export function ReferralCodeMetadataFromJSON(json: any): ReferralCodeMetadata {
    return ReferralCodeMetadataFromJSONTyped(json, false);
}

export function ReferralCodeMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralCodeMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sender_name': json['sender_name'],
    };
}

export function ReferralCodeMetadataToJSON(value?: ReferralCodeMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sender_name': value.sender_name,
    };
}

